var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('questionnaire', {
    key: new Date().getTime(),
    attrs: {
      "country": "Malaysia",
      "applymentId": _vm.detail.id,
      "applymentStatus": _vm.detail.applymentStatus,
      "questionnaire": _vm.detail.questionnaire,
      "businessType": _vm.detail.businessType,
      "fundInfoList": _vm.detail.fundInfoList || [],
      "businessGenre": _vm.detail.businessGenre,
      "registeredOfficeType": _vm.detail.registeredOfficeType,
      "registeredOfficeAddress": _vm.detail.registeredOfficeAddress,
      "registeredOfficeCity": _vm.detail.registeredOfficeCity,
      "registeredOfficeCountry": _vm.detail.registeredOfficeCountry,
      "registeredOfficePostalCode": _vm.detail.registeredOfficePostalCode,
      "registeredOfficeId": _vm.detail.registeredOfficeId,
      "nativeRegisteredAddress": _vm.nativeRegisteredAddress,
      "isNeedNomineeDirector": _vm.isNeedNomineeDirector,
      "hasNomineeDirector": _vm.detail.hasNomineeDirector
    }
  }), _vm.detail.businessType === 'SERVICE_TRANSFER' || _vm.detail.businessType === 'COMPREHENSIVE_CUSTOMIZED' ? _c('shareholders-detail', {
    staticClass: "mt40",
    attrs: {
      "stepName": "kycQuestionnaire",
      "country": "Malaysia",
      "applymentId": _vm.detail.id,
      "applymentStatus": _vm.detail.applymentStatus,
      "companyMemberList": _vm.detail.companyMemberList,
      "hasNomineeDirector": _vm.detail.hasNomineeDirector,
      "businessType": _vm.detail.businessType,
      "appointNomineeDirector": _vm.detail.questionnaire.appointNomineeDirector || {
        type: null,
        name: null
      },
      "supplierList": _vm.detail.supplierList,
      "headline": "Information of the proposed company's officer(s)",
      "isNeedNomineeDirector": _vm.isNeedNomineeDirector
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }